module.exports = __webpack_public_path__ + "static/bayer2-bg-c7890b6fafd2f4a47650f03999dc2194.png";